import { LegendItem, GroupRowType } from "helpers/models";

/**
 * 根据legend排序分组数据
 * @param groupedData 需要排序的分组数据
 * @param legend 排序依据的图例
 * @returns 排序后的数据
 */
export function sortData(groupedData: GroupRowType[], legend: LegendItem): GroupRowType[] {
  // 如果没有数据或legend，直接返回原数据
  if (!groupedData || !Array.isArray(groupedData) || !legend) {
    return groupedData;
  }

  // 创建规则映射，用于确定每个值的排序优先级
  const orderMap = new Map();

  // 如果legend是数组格式
  if (Array.isArray(legend)) {
    legend.forEach((item, index) => {
      if (typeof item === "string") {
        orderMap.set(item, index);
      } else if (item && typeof item === "object" && item.title) {
        orderMap.set(item.title, index);
      }
    });
  } else if (legend.rules && Array.isArray(legend.rules)) {
    // 如果legend是对象格式，假设它有rules属性
    legend.rules.forEach((rule: any, index: number) => {
      if (rule && rule.title) {
        orderMap.set(rule.title, index);
      }
    });
  }

  // 对数据进行排序
  return [...groupedData].sort((a, b) => {
    // 获取排序依据的字段（假设是'category'或'title'）
    const aValue = a.label || "";
    const bValue = b.label || "";

    // 获取在legend中的排序位置
    const aOrder = orderMap.has(aValue) ? orderMap.get(aValue) : Infinity;
    const bOrder = orderMap.has(bValue) ? orderMap.get(bValue) : Infinity;

    // 比较排序位置
    return bOrder - aOrder;
  });
}
